import { render } from "./AvailabilityForm.vue?vue&type=template&id=3ec3f6f4"
import script from "./AvailabilityForm.vue?vue&type=script&lang=js"
export * from "./AvailabilityForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__